/**
 * 類似日ピック記録 mutation hook。
 *
 * RecordSimilarDayPicks RPC を呼んで、担当者が類似日ダイアログで「適用」した
 * 類似日群 (execution_id + picked_dates) を記録する (AC-14)。
 * ADR demand-forecast-similar-day-persistence-shape: Pick は「担当者が採用した日」の
 * 記録であり、SearchSimilarDays 応答の execution_id を紐付けキーにする。
 *
 * fire-and-forget: 呼び出し元 (useSimilarDayFlow) は失敗を catch して無視し、
 * 「適用」操作自体はブロックしない。
 */
import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { recordSimilarDayPicks } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import {
  RecordSimilarDayPicksRequestSchema,
  RecordSimilarDayPicksResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 類似日ピックを記録する mutation hook。
 * request は caller が `create(RecordSimilarDayPicksRequestSchema, {...})` で組み立てて渡す。
 */
export function useRecordSimilarDayPicks(): UseMutationResult<
  MessageShape<typeof RecordSimilarDayPicksResponseSchema>,
  ConnectError,
  MessageInitShape<typeof RecordSimilarDayPicksRequestSchema>
> {
  return useMutation(recordSimilarDayPicks)
}
